"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { createStore } from "zustand/vanilla";
import { subscribeWithSelector } from "zustand/middleware";
import filterStore from "./filterStore";
import pointCounterStore from "./pointCounterStore";
const store = createStore(
  subscribeWithSelector((set, get) => ({
    isOpen: false,
    defaultFilters: {
      GeoScopeFilter: "all",
      GeoShowFilter: "all",
      GeoTimeFilter: "active",
      GeoType: "all",
      GeoSource: "all"
    },
    selectedFilters: {
      GeoScopeFilter: "all",
      GeoShowFilter: "all",
      GeoTimeFilter: "active",
      GeoType: "all",
      GeoSource: "all"
    },
    nextFilters: void 0,
    filterCount() {
      const { selectedFilters, defaultFilters } = store.getState();
      return Object.entries(selectedFilters).filter(([key, value]) => {
        return defaultFilters[key] !== value;
      }).length;
    },
    fromOptionsToFilters(filters = void 0) {
      if (!filters) filters = get().selectedFilters;
      const { activeFilters } = filterStore.getState();
      let newFilters = [...activeFilters];
      const withoutGeoShowFilter = (filters2) => filters2.filter((f) => {
        const [filterName] = Object.keys(f);
        return filterName !== "geoencodedFilter";
      });
      const withoutTimeFilter = (filters2) => filters2.filter((f) => {
        const [filterName] = Object.keys(f);
        return filterName !== "timeFilter";
      });
      const withoutTypeFilter = (filters2) => filters2.filter((f) => {
        const [filterName] = Object.keys(f);
        return filterName !== "resourceTypeFilter";
      });
      const withoutGeoScopeFilter = (filters2) => filters2.filter((f) => {
        const [filterName] = Object.keys(f);
        return filterName !== "scopeFilter";
      });
      const withoutGeoSourceFilter = (filters2) => filters2.filter((f) => {
        const [filterName] = Object.keys(f);
        return filterName !== "sourceFilter";
      });
      const withoutSearchFilter = (filters2) => filters2.filter((f) => {
        const [filterName] = Object.keys(f);
        return filterName !== "searchFilter";
      });
      switch (filters.GeoSource) {
        case "all":
          newFilters = [
            ...withoutGeoSourceFilter(newFilters),
            {
              sourceFilter: { source: "all" }
            }
          ];
          break;
        case "children_only":
          newFilters = [
            ...withoutGeoSourceFilter(newFilters),
            {
              sourceFilter: { source: "children_only" }
            }
          ];
          break;
        case "generator_only":
          newFilters = [
            ...withoutGeoSourceFilter(newFilters),
            {
              sourceFilter: { source: "generator_only" }
            }
          ];
          break;
      }
      switch (filters.GeoShowFilter) {
        case "all":
          newFilters = withoutGeoShowFilter(newFilters);
          break;
        case "geoencoded":
          newFilters = [
            ...withoutGeoShowFilter(newFilters),
            {
              geoencodedFilter: { geoencoded: true }
            }
          ];
          break;
        case "virtual":
          newFilters = [
            ...withoutGeoShowFilter(newFilters),
            {
              geoencodedFilter: { geoencoded: false }
            }
          ];
          break;
      }
      const filteredScopeId = filters.GeoScopeFilter || "all";
      switch (filteredScopeId) {
        case "all":
          newFilters = withoutGeoScopeFilter(newFilters);
          break;
        default:
          newFilters = [
            ...withoutGeoShowFilter(newFilters),
            {
              scopeFilter: { scopeId: `${filteredScopeId}` }
            }
          ];
          break;
      }
      const timeFilter = filters.GeoTimeFilter;
      if (timeFilter)
        newFilters = [
          ...withoutTimeFilter(newFilters),
          {
            timeFilter: { time: timeFilter }
          }
        ];
      const searchFilter = filters.GeoSearch;
      if (searchFilter == "empty") newFilters = withoutSearchFilter(newFilters);
      const resourceType = filters.GeoType;
      if (resourceType) {
        const id = document.querySelector(".decidimGeo__container").id;
        switch (id) {
          case "GeoAccountability":
          case "GeoProposals":
          case "GeoProposalsItem":
          case "GeoDebatesItem":
          case "GeoMeetings":
          case "GeoMeetingsItem":
            if (resourceType === "all") {
              newFilters = [
                ...withoutTypeFilter(newFilters),
                { resourceTypeFilter: { resourceType: "proposals" } },
                { resourceTypeFilter: { resourceType: "debates" } },
                { resourceTypeFilter: { resourceType: "meetings" } },
                { resourceTypeFilter: { resourceType: "accountability" } }
              ];
            } else {
              newFilters = [
                ...withoutTypeFilter(newFilters),
                {
                  resourceTypeFilter: { resourceType }
                }
              ];
            }
            break;
          default:
            newFilters = [
              ...withoutTypeFilter(newFilters),
              {
                resourceTypeFilter: { resourceType }
              }
            ];
            break;
        }
      }
      return newFilters;
    },
    setNextFilter(name, value) {
      set((state) => ({
        nextFilters: __spreadProps(__spreadValues({}, state.nextFilters), {
          [`${name}`]: value || state.defaultFilters[`${name}`]
        })
      }));
    },
    applyNextFilters() {
      set(({ nextFilters }) => nextFilters ? { selectedFilters: nextFilters } : {});
    },
    resetFilters() {
      set(({ defaultFilters }) => ({
        selectedFilters: defaultFilters,
        nextFilters: defaultFilters
      }));
    },
    setDefaultFilters(newFilters) {
      set(() => ({ defaultFilters: newFilters, selectedFilters: newFilters }));
    },
    setFilter(name, value) {
      const prevState = get().selectedFilters;
      if (prevState[name] === value) return;
      set((state) => ({
        selectedFilters: __spreadProps(__spreadValues(__spreadValues({}, state.defaultFilters), state.selectedFilters), {
          [`${name}`]: value || state.defaultFilters[`${name}`]
        })
      }));
    },
    toggleOpen() {
      set((state) => ({ isOpen: !state.isOpen }));
    },
    close() {
      set(() => ({ isOpen: false }));
    },
    open() {
      set(() => ({ isOpen: true }));
    }
  }))
);
export default store;
store.subscribe(
  (state) => [state.nextFilters],
  (_0, _1) => __async(void 0, [_0, _1], function* ([nextFilters], { prevFilter }) {
    const nextFilterKey = JSON.stringify(nextFilters);
    const prevFilterKey = JSON.stringify(prevFilter);
    if (_.isEqual(nextFilterKey, prevFilterKey)) return;
    const { updateNextCountForFilters } = pointCounterStore.getState();
    yield updateNextCountForFilters(store.getState().fromOptionsToFilters(nextFilters));
  })
);
